import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import CommonBanner from '../common/Banner';

const ItFits: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('ItFits');

    const imagePC = ['us', 'ca', 'ph'].includes(locale)
        ? 'https://websiteoss.ecoflow.com/upload/image/1753673068190/pc-1.jpg'
        : 'https://websiteoss.ecoflow.com/figma-uploads/1756782381770-05rdkg-compressed-%E9%9B%86%E5%90%88_3%201.jpg';
    const imagePad = ['us', 'ca', 'ph'].includes(locale)
        ? 'https://websiteoss.ecoflow.com/upload/image/1753673068388/pc-3.jpg'
        : 'https://websiteoss.ecoflow.com/figma-uploads/1756782469184-9e1zmw-compressed-%E9%9B%86%E5%90%88_3%201.jpg';
    const imageH5 = ['us', 'ca', 'ph'].includes(locale)
        ? 'https://websiteoss.ecoflow.com/upload/image/1753673068388/pc-3.jpg'
        : 'https://websiteoss.ecoflow.com/figma-uploads/1756782486295-3g2crj-compressed-%E9%9B%86%E5%90%88_3%201.jpg';

    return (
        <div className="ItFits GtmModuleData-section" data-section-id="ItFits" id="ItFits">
            <CommonBanner title={t('title')} pc={imagePC} pad={imagePad} h5={imageH5} />
        </div>
    );
};

export default ItFits;
